var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgName = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22.536,
    viewBox: "0 0 20 22.536",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.574,10.328a4.664,4.664,0,1,1,4.664-4.664A4.664,4.664,0,0,1,14.574,10.328Zm0-7.8a3.132,3.132,0,1,0,3.132,3.132A3.132,3.132,0,0,0,14.574,2.532Z",
    transform: "translate(-4.574 -1)",
    fill: "#959cf2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.172,26.9H7.928A4.233,4.233,0,0,1,3.55,22.849c0-4.33,3.791-7.84,8.466-7.849h3.068c4.675.008,8.461,3.519,8.466,7.849A4.233,4.233,0,0,1,19.172,26.9ZM12.016,16.488a6.628,6.628,0,0,0-6.859,6.361,2.683,2.683,0,0,0,2.771,2.567H19.172a2.683,2.683,0,0,0,2.771-2.567,6.628,6.628,0,0,0-6.859-6.361Z",
    transform: "translate(-3.55 -4.367)",
    fill: "#3953fb"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgName, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/name.1450c39d.svg";
export { ForwardRef as ReactComponent };